enum SlackListType {
  CHANNEL = 1,
  USER = 2,
}

export default SlackListType
